module.exports = __webpack_public_path__ + "img/toal-back.ecf1d960.svg";